import React, { Component } from 'react';
import ViewsTable from '../../components/tables/ViewsTable';
import AddVirtualLinkModal from './modals/addVirtualLinkModal';
import FieldModal from '../../components/modals/fieldModal';
import API from '../../utils/API';

class VirtualLinks extends Component {
    constructor(props) {
        super(props);

        const columnDefs = {
            name: 'Name',
            url: 'URL',
            type: 'Type',
        };
        const columnTypes = {
            name: 'text',
            url: 'link',
            type: 'text',
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columnDefs).map((key) => {
            toggledColumns[key] = true;
            return {
                label: columnDefs[key],
                key,
                value: key,
                type: columnTypes[key],
                sortAsc: false,
                sortDesc: false,
            };
        });

        this.state = {
            checked: {},
            addModalOpen: false,
            editModalOpen: false,
            deleteConfirmOpen: false,
            selectedLink: null,
            linkToDelete: null,
            linkToDeleteData: null,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort: null,
            sortDesc: false,
        };
    }

    getVirtualLinks = () => {
        const { accountData } = this.props;
        return accountData.virtualLinks || [];
    };

    handleAddLink = (linkData) => {
        const { accountData, editAccountData, orgId } = this.props;
        const virtualLinks = this.getVirtualLinks();

        const newLink = {
        };
        if (linkData.linkType === 'custom') {
            newLink.name = linkData.name;
            newLink.url = linkData.url;
        } else if (linkData.linkType === 'aws') {
            newLink.channelName = linkData.name;
        }

        //console.log({ linkData });
        // Save to server using dedicated virtual links endpoint
        API().post(`/Organizations/${orgId}/virtualLink`, {
            request: 'create',
            ...newLink
        })
            .then((res) => {
                if (res.data) {
                    const updatedAccountData = {
                        ...accountData,
                        virtualLinks: [...virtualLinks, res.data]
                    };
                    editAccountData(updatedAccountData, true);

                }
                this.setState({ addModalOpen: false });
            });
    };

    handleEditLink = (linkData) => {
        const { accountData, editAccountData, orgId } = this.props;
        const { selectedLink } = this.state;
        const virtualLinks = this.getVirtualLinks();

        const updatedLinks = virtualLinks.map(link => {
            if (link._id === selectedLink._id) {
                return {
                    ...link,
                    ...linkData
                };
            }
            return link;
        });

        const updatedAccountData = {
            ...accountData,
            virtualLinks: updatedLinks
        };

        editAccountData(updatedAccountData, true);

        // Save to server using dedicated virtual links endpoint
        API().post(`/Organizations/${orgId}/virtualLink`, {
            request: 'update',
            virtualLinkId: selectedLink._id,
            name: linkData.name,
            url: linkData.url,
        })
            .then(() => {
                this.setState({ editModalOpen: false, selectedLink: null });
            });
    };

    handleDeleteClick = (linkId) => {
        const virtualLinks = this.getVirtualLinks();
        const link = virtualLinks.find(l => l._id === linkId);
        this.setState({
            deleteConfirmOpen: true,
            linkToDelete: linkId,
            linkToDeleteData: link || null
        });
    };

    handleConfirmDelete = () => {
        const { accountData, editAccountData, orgId } = this.props;
        const { linkToDelete } = this.state;
        const virtualLinks = this.getVirtualLinks();

        const updatedLinks = virtualLinks.filter(link => link._id !== linkToDelete);

        const updatedAccountData = {
            ...accountData,
            virtualLinks: updatedLinks
        };

        editAccountData(updatedAccountData, true);

        // Save to server using dedicated virtual links endpoint
        API().post(`/Organizations/${orgId}/virtualLink`, {
            request: 'delete',
            virtualLinkId: linkToDelete
        });

        this.setState({
            deleteConfirmOpen: false,
            linkToDelete: null,
            linkToDeleteData: null
        });
    };

    handleCancelDelete = () => {
        this.setState({
            deleteConfirmOpen: false,
            linkToDelete: null,
            linkToDeleteData: null
        });
    };

    toggleAddModal = () => {
        this.setState({ addModalOpen: !this.state.addModalOpen });
    };

    toggleEditModal = (link = null) => {
        this.setState({
            editModalOpen: !this.state.editModalOpen,
            selectedLink: link
        });
    };

    checkRow = (id) => {
        const { checked } = this.state;
        const newChecked = { ...checked };
        if (newChecked[id]) {
            delete newChecked[id];
        } else {
            newChecked[id] = true;
        }
        this.setState({ checked: newChecked });
    };

    checkAllRows = (ids) => {
        const newChecked = {};
        ids.forEach(id => {
            newChecked[id] = true;
        });
        this.setState({ checked: newChecked });
    };

    renderLinksTable = () => {
        const { normalizedColumns, toggledColumns, checked, selectedColumnSort, sortDesc } = this.state;
        const virtualLinks = this.getVirtualLinks();
        const columnWidths = {
            name: 200,
            url: 500,
            type: 120,
        };

        let data = virtualLinks.map(link => ({
            ...link,
            type: link.channelBroadcast?.arn ? 'AWS' : 'Custom',
        }));

        const sortData = (column, sortAsc, sortDescVal) => {
            const updatedColumns = normalizedColumns.map((col) => {
                if (col.key === column.key) {
                    col.sortAsc = sortAsc;
                    col.sortDesc = sortDescVal;
                } else {
                    col.sortAsc = false;
                    col.sortDesc = false;
                }
                return col;
            });
            this.setState({
                normalizedColumns: updatedColumns,
                selectedColumnSort: column,
                sortDesc: sortDescVal,
            });
        };

        if (selectedColumnSort) {
            data = data.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });
            data = sortDesc ? data.reverse() : data;
        }

        const rowSettings = [
            {
                label: 'Edit',
                onClick: (id) => {
                    const link = virtualLinks.find(l => l._id === id);
                    this.toggleEditModal(link);
                },
            },
            {
                label: 'Delete',
                onClick: (id) => {
                    this.handleDeleteClick(id);
                },
            },
            {
                label: 'Copy Link',
                onClick: (id) => {
                    const link = virtualLinks.find(l => l._id === id);
                    if (link && link.url) {
                        navigator.clipboard.writeText(link.url).catch(err => console.error('Failed to copy link: ', err));
                    }
                },
            },
        ];

        return (
            <ViewsTable
                title='Virtual Links'
                columns={normalizedColumns}
                toggledColumns={toggledColumns}
                data={data}
                mainColumnActive={false}
                checked={checked}
                mainActions={[]}
                sortData={sortData}
                disableCheck={true}
                columnWidths={columnWidths}
                rowSettings={rowSettings}
                disableColumnResizing={true}
                checkRow={this.checkRow}
                checkAllRows={this.checkAllRows}
            />
        );
    };

    render() {
        const { addModalOpen, editModalOpen, selectedLink, linkToDeleteData } = this.state;
        const virtualLinks = this.getVirtualLinks();

        return (
            <div className="sectionBody pt-0 h-100 d-flex flex-column">
                <h1 className='mb-20'>Virtual Links</h1>
                <div className=' p-20 flex-grow-1 d-flex flex-column'>
                    <div className='flex jcsb aic mb-20'>
                        <h2 className='semibold'>Manage Virtual Links</h2>
                        <button
                            className='prim'
                            onClick={this.toggleAddModal}
                        >
                            <i className='las la-plus mr-10'></i>
                            Add Virtual Link
                        </button>
                    </div>

                    {this.renderLinksTable()}
                </div>

                {addModalOpen && (
                    <AddVirtualLinkModal
                        isOpen={addModalOpen}
                        toggle={this.toggleAddModal}
                        onSave={this.handleAddLink}
                        mode="add"
                        existingLinks={virtualLinks}
                    />
                )}

                {editModalOpen && selectedLink && (
                    <AddVirtualLinkModal
                        isOpen={editModalOpen}
                        toggle={() => this.toggleEditModal()}
                        onSave={this.handleEditLink}
                        mode="edit"
                        linkData={selectedLink}
                        existingLinks={virtualLinks}
                    />
                )}

                {/* Delete Confirmation Modal */}
                {this.state.deleteConfirmOpen && (() => {
                    const isAws = linkToDeleteData && !!linkToDeleteData.channelBroadcast?.arn;
                    return (
                        <FieldModal
                            size="small"
                            isOpen={this.state.deleteConfirmOpen}
                            modalTitle="Delete Virtual Link"
                            bodyHeaderText={<span>You are about to delete <b>{linkToDeleteData?.name}</b>{isAws ? ' (AWS Channel)' : ''}, this is irreversible, would you like to continue?</span>}
                            bodyContent={() => ''}
                            toggle={this.handleCancelDelete}
                            actionButtonLabel="Delete"
                            actionButton={this.handleConfirmDelete}
                            isDelete={true}
                        />
                    );
                })()}
            </div>
        );
    }
}

export default VirtualLinks;
